const debounce = require('throttle-debounce/debounce');

$(document).ready(function () {
	function setTooltipPosition() {
		$('.tooltip').not('#cboxLoadedContent .tooltip').each(function (index, el) {
			const $this = $(this);
			var tooltipText = $this.find('.tooltip__text:not(.tooltip__text--static)');

			if (tooltipText.length) {
				const $content = $('.content');
				const contentLeft = $content.length ? $content.offset().left : 0;
				const contentWidth = $content.length ? $content.width() : 0;
				const tooltipModifirSelectors = 'tooltip__text--left tooltip__text--right tooltip__text--to-top tooltip__text--to-bot tooltip__text--to-left tooltip__text--to-right';
				tooltipText.removeClass(tooltipModifirSelectors);
				var tooltipWidth = $this.width(),
					tooltipTextWidth = tooltipText.width()
						+ Number(tooltipText.css('padding-left').replace('px', ''))
						+ Number(tooltipText.css('padding-right').replace('px', '')),
					tooltipTextMargin = (tooltipWidth / 2) - (tooltipTextWidth / 2),
					tooltipSideMod = (tooltipTextWidth - tooltipWidth) / 2,
					tooltipAllWidth = tooltipWidth + tooltipTextWidth,
					tooltipLeftBound = $this.offset().left - contentLeft,
					tooltipRightBound = tooltipLeftBound + tooltipAllWidth,
					tooltipRightBoundPiece = contentWidth - (tooltipLeftBound + tooltipWidth);

				//Если подсказке жестко не задан класс, то проверить
				if (!tooltipText.hasClass('tooltip__text--static') && !tooltipText.hasClass('tooltip__text--bottom')) {
					//влезает ли подсказка справа от выделенного текста в родительский блок
					if ($this.parents('.content')[0] != undefined) {
						if (tooltipRightBound > contentWidth && tooltipLeftBound > tooltipTextWidth) {
							tooltipText.addClass('tooltip__text--left');
						} else if (tooltipRightBound > contentWidth) {
							tooltipText.addClass('tooltip__text--bottom');
							checkBottomPos ();
						}
					//проверить, что родителем является правая колонке, если так, то повернуть подсказку влево
					} else if ($this.parents('.right-sidebar')[0] != undefined) {
						tooltipText.addClass('tooltip__text--left');
					}
				// иначе, если подсказке задано положение снизу, то проверить влезает ли подсказка слева и справа в .content
				} else if (!tooltipText.hasClass('tooltip__text--static') && tooltipText.hasClass('tooltip__text--bottom')) {
					checkBottomPos ();
				}

				//Проверить влезает ли подсказка расположенная снизу слева и справа в .content, если не влазит в одну из сторон, то прижать к противоположному краю
				//Если влазит слева и справа, то расположить его по центру выделенного текста
				function checkBottomPos() {
					if (tooltipLeftBound < tooltipSideMod) {
						tooltipText.addClass('tooltip__text--to-left');
					} else if (tooltipRightBoundPiece < tooltipSideMod) {
						tooltipText.addClass('tooltip__text--to-right');
					} else {
						tooltipText.css('margin-left', tooltipTextMargin);
					}
				}
			}
		});
	}

	function createSup() {
		$('.tooltip').each(function (index, el) {
			const $this = $(this);
			//Генерация сносок для печатной версии
			$this
				.append(`<sup class="tooltip-number">${(index + 1)}</sup>`);
			$('.content')
				.append(`<p class="footnotes"><sup>${(index + 1)}</sup> ${$this.find('.tooltip__text').text()}</p>`);

			$this.find('.tooltip__text').wrapInner('<span>');
		});
	}

	//После загрузки модалки проверить, если в ней присутствуют тултипы, то проверить
	$(document).bind('cbox_complete', function () {
		$('#cboxLoadedContent .tooltip').each(function () {
			var $this = $(this),
				$modalContent = $('#cboxLoadedContent'),
				tooltipText = $this.find('.tooltip__text'),
				tooltipTopBound = $this.offset().top - $modalContent.offset().top,
				tooltipBotBound = ($modalContent.height() + $modalContent.offset().top) - ($this.offset().top + $this.height()),
				tooltipHeight = (tooltipText.height() + Number(tooltipText.css('padding-top').replace('px', '')) + Number(tooltipText.css('padding-bottom').replace('px', ''))) / 2;
			//влезает ли он сверху, то прижать его к верхней грацнице выделенного текста
			if (tooltipTopBound < tooltipHeight && !tooltipText.hasClass('tooltip__text--bottom')) {
				tooltipText.addClass('tooltip__text--to-top');

				let cboxWidth = $modalContent.width();
				let cboxLeftBound = $modalContent.offset().left;
				let tooltipRightBound = $this.offset().left + $this.width() - cboxLeftBound + tooltipText.outerWidth();

				if (tooltipRightBound > cboxWidth) {
					tooltipText.attr('class', 'tooltip__text').addClass('tooltip__text--bottom');

					let tooltipLeftBound = $this.offset().left - cboxLeftBound;
					let tooltipSideMod = (tooltipText.width() - $this.width()) / 2;
					let tooltipRightBoundPiece = cboxWidth - (tooltipLeftBound + $this.width());

					if (tooltipText.outerWidth() > cboxWidth) {
						let tooltipTextPadding = Number(tooltipText.css('padding-left').replace('px', '')) + Number(tooltipText.css('padding-right').replace('px', ''));
						tooltipText
							.width(cboxWidth - Math.round(tooltipTextPadding))
							.css('left', -tooltipLeftBound);
					} else if (tooltipLeftBound < tooltipSideMod) {
						tooltipText.addClass('tooltip__text--to-left');
					} else if (tooltipRightBoundPiece < tooltipSideMod) {
						tooltipText.addClass('tooltip__text--to-right');
					} else {
						tooltipText.css('margin-left', tooltipTextMargin);
					}
				}
			//иначе, если не влезает снизу, то прижать его к нижней границе выделенного текста
			} else if (tooltipBotBound < tooltipHeight) {
				tooltipText.addClass('tooltip__text--to-bot');
			}
		});
	});

	createSup();
	setTooltipPosition();

	$(window).resize(debounce(1000, setTooltipPosition));
});



// WEBPACK FOOTER //
// ./temp/components/tooltips/index.js